/**
 * NotificationRoadmapKind
 *
 * The six roadmap notification sub-types rendered by
 * `NotificationRoadmapItem`. Web-local discriminant (no Flutter enum to
 * ordinal-match); string-valued for clearer debugging, mirroring
 * `inboxItemType.ts`. Per `conventions.md` § "Enums live in the domain layer",
 * it lives in the domain layer even though its first consumer is
 * presentation-local.
 */
export enum NotificationRoadmapKind {
  roadmapLike = 'roadmapLike',
  roadmapDislike = 'roadmapDislike',
  roadmapComment = 'roadmapComment',
  roadmapCommentReply = 'roadmapCommentReply',
  roadmapCommentLike = 'roadmapCommentLike',
  roadmapDonation = 'roadmapDonation',
}
